import { BallTriangle } from 'react-loader-spinner';

const RTSpinner = ({ message = "Loading...", size = 70, fullScreen = false, showMessage = true, style = {}, color = "#153C7F" }) => {
  // Handle size prop - convert "small" to actual number
  const actualSize = size === "small" ? 16 : (typeof size === 'number' ? size : 70);
  
  // Use white color for small spinners (typically used in buttons)
  const spinnerColor = size === "small" ? "#ffffff" : color;
  
  const containerStyle = fullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    backgroundColor: 'white',
    zIndex: 9999,
    ...style
  } : {
    display: 'flex',
    flexDirection: size === "small" ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent', // Ensure no background for inline usage
    minHeight: size === "small" ? 'auto' : 'auto', // Prevent height expansion
    ...style
  };

  return (
    <div style={containerStyle}>
      <BallTriangle
        height={actualSize}
        width={actualSize}
        radius={size === "small" ? 1 : 5}
        color={spinnerColor}
        ariaLabel="ball-triangle-loading"
        visible={true}
      />
      {showMessage && (
        <div style={{ 
          marginTop: size === "small" ? 0 : 12, 
          marginLeft: size === "small" ? 4 : 0,
          color: '#153C7F', 
          fontWeight: 500,
          fontSize: size === "small" ? '12px' : 'inherit'
        }}>
          {message}
        </div>
      )}
    </div>
  );
};

export default RTSpinner;